import { render, staticRenderFns } from "./OnlineOrderMngQpage.vue?vue&type=template&id=27057515&scoped=true&"
import script from "./OnlineOrderMngQpage.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderMngQpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27057515",
  null
  
)

export default component.exports